module.exports = __webpack_public_path__ + "static/invest-and-trade-home-b175d89b5718d8d7da770f90a5d0320f.mp4";